import React, {useEffect, useState} from "react";
import Avatar from "../../../system/components/avatar";
import Icon from "../../../system/components/icon";
import {formatPersianDate} from "../../../models/goal-update/goal-update-api";
import {PROJECT_STATES, projectUpdateApi} from "../../../models/project-update/project-update-api";
import ProjectUpdateViewDialog, {ProjectStateChip} from "./project-update-view-dialog";
import "../../goals/components/goal-updates.css";
import "./project-updates.css";
import {richTextToPlain} from "../../../system/components/rich-text";

// The project page's side column: published updates newest first (+ entries of the old `timeline` field); a click opens
// the view modal (docs/tasks/18-project-updates.md).

const TONE_CLASS = {green: "pu-tone-green", orange: "pu-tone-orange", red: "pu-tone-red", gray: "pu-tone-gray"};

function ProjectUpdatesList({projectData}) {
    const [updates, setUpdates] = useState(null);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (!projectData?.documentId) return;
        let cancelled = false;
        projectUpdateApi.context(projectData.documentId)
            .then((data) => { if (!cancelled) setUpdates(data.updates || []); })
            .catch(() => { if (!cancelled) setUpdates([]); });
        return () => { cancelled = true; };
    }, [projectData?.documentId, projectData?.projectStatus, projectData?.lastPublishedUpdateAt]);

    const legacy = (Array.isArray(projectData?.timeline) ? projectData.timeline : []).map((entry, index) => ({
        key: `legacy-${index}`,
        selectedState: entry?.projectStatus,
        summary: entry?.briff || "",
        nextActions: Array.isArray(entry?.decisions) ? entry.decisions : [],
        createdAt: entry?.createdAt,
        project: projectData ? {id: projectData.id, documentId: projectData.documentId, title: projectData.title} : null,
    }));
    const items = [...(updates || []), ...legacy].sort((left, right) => new Date(right.publishedAt || right.createdAt || 0) - new Date(left.publishedAt || left.createdAt || 0));

    return (
        <div className="gu flex flex-column gap-3" dir="rtl">
            <span className="gu-section-title">به‌روزرسانی‌های پروژه</span>
            {updates === null && <span className="text-xs gu-muted">در حال دریافت…</span>}
            {updates !== null && !items.length && <div className="gu-card p-3 text-xs gu-muted" style={{lineHeight: 1.9}}>هنوز به‌روزرسانی‌ای منتشر نشده است.</div>}
            {items.map((item) => {
                const config = PROJECT_STATES[item.selectedState];
                return (
                    <button key={item.documentId || item.key} type="button" className={`pu-history-card ${TONE_CLASS[config?.tone] || "pu-tone-gray"}`} onClick={() => setSelected(item)}>
                        <div className="flex align-items-center justify-content-between w-full gap-2">
                            {config ? <ProjectStateChip state={item.selectedState}/> : <span className="gu-chip gu-tone-gray">ثبت</span>}
                            <span className="text-2xs gu-muted">{formatPersianDate(item.publishedAt || item.createdAt)}</span>
                        </div>
                        {item.summary && <span className="text-xs" style={{lineHeight: 1.8, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden"}}>{richTextToPlain(item.summary)}</span>}
                        {item.author?.member && (
                            <span className="flex align-items-center gap-2 text-2xs gu-muted">
                                <Avatar memberData={item.author.member} style={{width: "1.4rem", height: "1.4rem"}} className="text-3xs"/>{item.author.member.fullname}
                                {item.progressSnapshot !== null && item.progressSnapshot !== undefined && <span className="mr-auto">پیشرفت {Number(item.progressSnapshot).toLocaleString("fa-IR")}٪</span>}
                            </span>
                        )}
                    </button>
                );
            })}
            <div className="flex align-items-center gap-2 text-2xs gu-muted px-2"><Icon icon="mi mi:flag" className="text-sm"/>ایجاد پروژه · {formatPersianDate(projectData?.createdAt)}</div>
            <ProjectUpdateViewDialog
                visible={Boolean(selected)}
                update={selected?.documentId ? null : selected}
                updateId={selected?.documentId || null}
                project={projectData}
                onHide={() => setSelected(null)}
            />
        </div>
    );
}

export default ProjectUpdatesList;
